import { Token } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

function SelectedValue({
  value,
  className,
  children,
  removeOption,
}: {
  value: string
  className?: string
  children: string
  removeOption: (value: string) => void
}) {
  const handleRemoveClick = (value: string, event: React.MouseEvent) => {
    event.stopPropagation()
    removeOption(value)
  }

  return (
    <Token value={value} className={className} dismissible onDismissClick={handleRemoveClick}>
      {children}
    </Token>
  )
}

export default SelectedValue
